<div style="border: solid 1px gray; padding: 15px">
  <h1>Parent Component</h1>
  <span><b>Value emitted from child component is:</b></span>
  {{ valueEmittedFromChildComponent }}
  <app-test-child (buttonClicked)="parentEventHandlerFunction($event)">
  </app-test-child>
</div>
